import { Profile, useGetProfileQuery } from "~/schemas/generated/graphql";
import get from "lodash/get";

export const useCurrentUserInfo = (): [Profile | undefined, boolean] => {
  const { data, loading } = useGetProfileQuery({ fetchPolicy: "no-cache" });
  return [get(data, "UserGetter.getProfile"), loading];
};
